import { Suspense, StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClientProvider } from "@tanstack/react-query"
import { Provider } from "react-redux"
import { pdfjs } from "react-pdf"

import App from "./App"
import { queryClient } from "./Api"
import * as serviceWorker from "./serviceWorker"
import { configureStore } from "./redux/store"
// do not reorder these imports
import "react-circular-progressbar/dist/styles.css"
import "react-perfect-scrollbar/dist/css/styles.css"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "react-table/react-table.css"
import "react-toastify/dist/ReactToastify.css"
import "./assets/css/vendor/bootstrap.min.css"
import "./assets/css/sass/_gogo.style.scss"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const isDebugMode = window._env_.NODE_ENV === "development" && window._env_.DEBUG_MODE === "true"

const container = document.getElementById("root")
if (!container) {
  throw new Error("Failed to find the root element")
}

const AppWrapper: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <Provider store={configureStore({})}>
      {/* eslint-disable-next-line camelcase */}
      <BrowserRouter future={{ v7_startTransition: false, v7_relativeSplatPath: false }}>
        <Suspense fallback={<div className='loading' />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </Provider>
  </QueryClientProvider>
)

const AppWithStrictMode: React.FC = () => (
  <StrictMode>
    <AppWrapper />
  </StrictMode>
)

const root = createRoot(container)
root.render(isDebugMode ? <AppWithStrictMode /> : <AppWrapper />)

serviceWorker.unregister()
